// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand: #4a6cf7;
  --brand-light: #eef1ff;
  --text: #1a1a2e;
  --muted: #666;
  --bg: #f7f9fc;
}

/* Основная страница */
.PageLayout_page__Socy8 {
  background: var(--bg);
  height: 100%;
  padding: 1.2rem 1.8rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  box-sizing: border-box;
  flex: 1 1;
}

/* Заголовок */
.PageLayout_header__AjwcE {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
}

/* ======= Панели (controls + stats) ======= */
.PageLayout_panels__K1iTc {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 1rem;
  align-items: stretch;
}

/* Внешний вид панелей (если нужно применить к ним общий стиль) */
.PageLayout_panels__K1iTc > * {
  background: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  padding: 0.8rem 1rem;
  box-sizing: border-box;
}

/* Контент */
.PageLayout_content__HvFSM {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 1rem;
  min-height: 0;
  overflow: auto;
}

/* Адаптив */
@media (max-width: 768px) {
  .PageLayout_page__Socy8 {
    padding: 1rem;
  }

  .PageLayout_header__AjwcE {
    flex-direction: column;
    align-items: flex-start;
  }

  .PageLayout_panels__K1iTc {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/PageLayout.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,SAAO;AACT;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\r\n  --brand: #4a6cf7;\r\n  --brand-light: #eef1ff;\r\n  --text: #1a1a2e;\r\n  --muted: #666;\r\n  --bg: #f7f9fc;\r\n}\r\n\r\n/* Основная страница */\r\n.page {\r\n  background: var(--bg);\r\n  height: 100%;\r\n  padding: 1.2rem 1.8rem 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.4rem;\r\n  box-sizing: border-box;\r\n  flex: 1;\r\n}\r\n\r\n/* Заголовок */\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n/* ======= Панели (controls + stats) ======= */\r\n.panels {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\r\n  gap: 1rem;\r\n  align-items: stretch;\r\n}\r\n\r\n/* Внешний вид панелей (если нужно применить к ним общий стиль) */\r\n.panels > * {\r\n  background: #fff;\r\n  border-radius: 0.6rem;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\r\n  padding: 0.8rem 1rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Контент */\r\n.content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  gap: 1rem;\r\n  min-height: 0;\r\n  overflow: auto;\r\n}\r\n\r\n/* Адаптив */\r\n@media (max-width: 768px) {\r\n  .page {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .panels {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `PageLayout_page__Socy8`,
	"header": `PageLayout_header__AjwcE`,
	"panels": `PageLayout_panels__K1iTc`,
	"content": `PageLayout_content__HvFSM`
};
export default ___CSS_LOADER_EXPORT___;
